(function() {
  const contentDebug = false;
  // About Us
  const aboutUs = document.querySelector('[data-au-status]');

  // Reset Variables
  const intro = document.querySelector('[data-intro-status]');
  const resetButton = document.querySelector('[data-reset-button] ');
  const resetContent = document.querySelector('[data-reset-status]');
  const backButton = document.querySelector('.k-au-menu--back');
  let backedState = false;

  // Content Variables
  const aboutUsContent = document.querySelector('[data-au-content]');
  // const parentSlider = document.querySelector('[data-au-sliders]');
  // let parentSliderSwiper;
  const hiddenClass = 'k-au-slider-menu--hidden';
  const hiddenDom = document.querySelectorAll(`.${hiddenClass}`);

  // Menu 
  const mobileSelect = document.querySelector('[data-au-s-option]');
  const mobileOptionsWrapper = document.querySelector('[data-au-options]');

  // Down Arrow
  const downArrow = document.querySelector('.k-au-content .k-au-down-arrow');
  let downArrowPosition = 0;

  const toggleMenu = () => {
    const currentStatus = mobileSelect.dataset.status === 'active'
      ? 'hidden' : 'active';
    mobileSelect.dataset.status = currentStatus;
    mobileOptionsWrapper.dataset.status = currentStatus;
  };

  const initMenu = () => {
    mobileSelect.addEventListener('click', (e) => {
      toggleMenu();
    });
  };

  const menuOptions = slider => {
    const sliderPosition = slider.dataset.auSlider;
    const currentOption = document.querySelectorAll(`[data-au-menu-button="${sliderPosition}"]`);
    const allOptions = document.querySelectorAll('[data-au-menu-button]');

    if(currentOption.length) {
      currentOption.forEach(option => {
        option.addEventListener('click', (e) => {
          // allOptions.forEach(op => op.dataset.status = '');
          // option.dataset.status = 'active';
          // Set body not to move when scrolling
          document.querySelector('body').scrollTo({top: 0});
          aboutUsContent.scrollTo({
            top: document.querySelector(`#${option.dataset.toSlide?.split('#')[1]}`).offsetTop - aboutUsContent.offsetTop + 100,
            behavior: 'smooth'
          });
          
          if(option.dataset.auOption != undefined) {
            toggleMenu();
          }
        });
      });
    }
  };

  const setSlideMaxHeight = (swiper, slider) => {
    swiper.slides.forEach(slide => {
      slide.style.height = "auto";
    });
    const heights = [];
    swiper.slides.forEach(slide => {
      heights.push(slide.clientHeight);
    });
    const maxHeight = Math.max(...heights);
    swiper.slides.forEach(slide => {
      slide.style.height = maxHeight + "px";
    });
  };

  const toggleMenuHidden = () => {
    setTimeout(() => {
      hiddenDom.forEach(dom => {
        dom.classList.toggle(hiddenClass);
      });
    }, 500);
  }

  const initContent = () => {
    const sliderInSlider = document.querySelectorAll('[data-au-slider]');
    aboutUs.dataset.auStatus = 'content'; 

    window.swipers = [];
    sliderInSlider.forEach(slider => {
      var swiper2 = new Swiper(slider, {
        slidesPerView: 1.2,
        observer: true,
        breakpoints: {
          991: {
            slidesPerView: 2,
          }
        },
        on: {
          afterInit: function (swiper) {
            setTimeout(() => {
              setSlideMaxHeight(swiper, slider);
            }, 500);
          },
          breakpoint: function (swiper) {
            setTimeout(() => {
              setSlideMaxHeight(swiper, slider, true);
            }, 500);
          },
          resize: function (swiper) {
            let resize;
            clearTimeout(resize)
            resize = setTimeout(() => {
              setSlideMaxHeight(swiper, slider, true);
            }, 500);
          },

        }
      });

      const dragText = slider.querySelector('.k-au-drag-text');
      dragText.addEventListener('click', () => {
        swiper2.slideNext();
      })
      menuOptions(slider);
      const bannerSlider = slider.querySelector('.k-slider__carrousel');

      if(bannerSlider) {
        const bannerSwiper = new Swiper(bannerSlider, {
          slidesPerView: 1.2,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets'
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            991: {
              slidesPerView: 3,
            }
          },
        });
      }

      window.swipers.push(swiper2);
    });

  };

  if(resetButton) {
    resetButton.addEventListener('click', () => {
      aboutUs.dataset.auStatus = 'transition';
      intro.dataset.introStatus = 'hidden';
      resetContent.dataset.resetStatus = 'active';
      setTimeout(() => {
        window.scroll({
          top: 0, 
          left: 0,
          behavior: 'smooth'
        });
      }, 500);
      setTimeout(() => {
        intro.style.display = 'none';
        resetContent.style.display = 'none';
        
        aboutUsContent.dataset.auContent = 'active';
        toggleMenuHidden();
        if(backedState) {
          aboutUs.dataset.auStatus = 'content';
        } else {
          initContent();
          initMenu();
        }
      }, 3500);
    });
  }
  
  if(backButton) {
    backButton.addEventListener('click', () => {
      backedState = true;
      aboutUs.dataset.auStatus = 'intro';
      aboutUsContent.dataset.auContent = 'hidden';
      intro.style.display = 'block';
      intro.dataset.introStatus = 'active';
      resetContent.style.display = 'block';
      resetContent.dataset.resetStatus = 'hidden';
      toggleMenuHidden();
    });
  }

  if(contentDebug) {
    aboutUsContent.dataset.auContent = 'active';
    intro.style.display = 'none';
    resetContent.style.display = 'none';
    toggleMenuHidden();
    initContent();
    initMenu();
  }
  
  // Start Timer for Skincare Moves Fast section
  const startTimer = () => {
    const timer = document.querySelector('[data-countup]');
    const timerText = timer.querySelector('p');
    const goal = 120000000000;
    let count = 0;
    const timerInterval = setInterval(() => {
      if (count >= goal ) {
        clearInterval(timerInterval);
      } else {
        count = count + 3805;
        let newCount = Number(goal.toString().length) - Number(count.toString().length);
        let newCountString = count.toString();
        // append 0 to the beginning of the number
        for (let i = 0; i < newCount; i++) {
          newCountString = `0${newCountString}`;
        }
        timerText.innerHTML = newCountString;
      }
      
    }, 1000);
  };

  startTimer();

  let oldScroll = 0;

  aboutUsContent.addEventListener('scroll', e => {
      const newScroll = aboutUsContent.scrollTop;
      const scrollPos = aboutUsContent.scrollTop;
      const slide1 = document.querySelector('#slider-1').offsetTop;
      const slide2 = document.querySelector('#slider-2').offsetTop;
      const slide3 = document.querySelector('#slider-3').offsetTop;

      console.log(scrollPos, slide1, slide2, slide3)

      if(scrollPos < slide2 ) {
        downArrowPosition = 1;
      } else if(scrollPos < (slide3-100)) {
        downArrowPosition = 2;
      } else if(scrollPos >= (slide3-250)) {
        downArrowPosition = 3;
      }

      if(scrollPos >= (slide3-250)) { 
        if(window.innerWidth <= 768) {
          downArrow.style.display = 'none';
        }
      } else {
        console.log(downArrowPosition)
        if(window.innerWidth <= 768) {
          downArrow.style = ""
        }
      }

      if(oldScroll - newScroll > 0) {
        window.scroll({
          top: 0, 
          left: 0,
          behavior: 'smooth'
        });
      }

      const parentClass = (window.innerWidth <= 768) ? '.k-au-menu__select' : '.k-au-menu__content';

      const selectToScroll = document.querySelector(`${parentClass} [data-au-menu-button="${downArrowPosition}"]`);
      
      if (window.innerWidth <= 768) {
        mobileSelect.querySelector('img').src = selectToScroll.querySelector('img').src;
        mobileSelect.querySelector('p').innerHTML = selectToScroll.querySelector('p').innerHTML;
      } else {
        const opts = document.querySelectorAll(`${parentClass} [data-au-menu-button]`);
        opts.forEach(op => op.dataset.status = '')
        selectToScroll.dataset.status = 'active';
      }
      
      oldScroll = newScroll;
  });

  downArrow.addEventListener('click', () => {
    if(window.innerWidth <= 768) {
      const scrollPos = aboutUsContent.scrollTop;
      const slide1 = document.querySelector('#slider-1').offsetTop;
      const slide2 = document.querySelector('#slider-2').offsetTop;
      const slide3 = document.querySelector('#slider-3').offsetTop;

      
      if(scrollPos >= slide1 && scrollPos < slide2) {
        downArrowPosition = 2
      } else if(scrollPos >= slide2 && scrollPos < slide3) {
        downArrowPosition = 3
      } 

      const selectToScroll = document.querySelector(`[data-au-menu-button="${downArrowPosition}"]`);
      selectToScroll.click();
    }
  });

  const shareHolders = document.querySelector('#slider-3');
  let transformCoinPosition = 0;
  let lastScrollPos = 0;
  let intersecting = false;
  let coinsScrolled = false;

  const checkCoinIntersection = () => {
    // Get a reference to the two DOM elements you want to check
    const element1 = document.querySelector('.k-slider__decorations[data-type="3"]');
    const element2 = document.querySelector('#slider-3 .k-slider__images');

    // Get the bounding rectangles of the elements
    const rect1 = element1.getBoundingClientRect();
    const rect2 = element2.getBoundingClientRect();

    // Check if the rectangles are intersecting
    return !(
      rect1.top < rect2.top
    );
  }

  const observer = new IntersectionObserver(entries => {
    // Check if the element is intersecting the viewport
    if (entries[0].isIntersecting) {
      const elementsToScroll = shareHolders.querySelectorAll('.k-slider__decorations');
      const dropInterval = setInterval(() => {
        elementsToScroll.forEach((element, i) => {
          if(checkCoinIntersection()) {
            element.style.opacity = 0;
            clearInterval(dropInterval);
          } else {
            if(!coinsScrolled) {
              element.style.marginTop = '600px';
            } else if(i === elementsToScroll.length - 1) {
              coinsScrolled = true;
            }
          }
        });
      }, 1000);
    } else {
      intersecting = false;
    }
  });

  observer.observe(shareHolders);

})();